var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "site-message" }, [
    _c("h1", [_vm._v("\n    " + _vm._s(_vm.messages.title[0]) + "\n  ")]),
    _vm._v(" "),
    _c("p", [_vm._v("\n    " + _vm._s(_vm.messages.default) + "\n  ")]),
    _vm._v(" "),
    _c("p", [_vm._v("\n    " + _vm._s(_vm.messages.pageNotFound) + "\n  ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }